import React, { useContext } from "react";
import { ShipmentContext } from "../../contexts/ShipmentContext.jsx";
import { translate } from "../../../utility/strings.js";

const ShipmentStatus = () => {

  let { shipment, loading } = useContext(ShipmentContext);
  
  console.log(shipment);

  if(loading){
    return <div className="my-10 text-center shipment-status">
              <h1 className="h3">
                <animate class="h-3 bg-lightest-grey rounded-lg text-transparent" data-animation="pulse">{translate("shipment_tracking.order_status", "Order Status:")}</animate><br/>
                <animate class="h-3 bg-lightest-grey rounded-lg text-transparent" data-animation="pulse">Loading...</animate>
              </h1>
            </div>;
  }

  return (
    <div className="my-10 text-center shipment-status">
      <h1 className="h3">
       {translate("shipment_tracking.order_status", "Order Status:")}<br/>
        <span class="font-light">{shipment.summary?.status}</span>
      </h1>
    </div>
  );

}

export default ShipmentStatus;
